import { Inject, Injectable } from '@angular/core';
import { AddressOptions } from '@liberty-financial/agp-shared';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { BrokerCapabilitiesService } from '@core/services/broker-capabilities.service';

/** Token `AgpSharedAddressModule.forRoot` registers the app-wide options under. */
export const ADDRESS_OPTIONS = 'agpSharedAddressOptions';

export function withOverseasManualEntry(
  appWide: AddressOptions,
  allowOverseas: boolean
): AddressOptions {
  if (!allowOverseas || appWide.manualEntry.countries.includes('intl')) {
    return appWide;
  }

  return {
    ...appWide,
    manualEntry: {
      ...appWide.manualEntry,
      countries: [...appWide.manualEntry.countries, 'intl']
    }
  };
}

@Injectable({
  providedIn: 'root'
})
export class ContactsOverseasAddressOptionsService {
  readonly options$: Observable<AddressOptions>;

  constructor(
    @Inject(ADDRESS_OPTIONS) appWide: AddressOptions,
    capabilities: BrokerCapabilitiesService
  ) {
    capabilities.load();
    this.options$ = capabilities.whenReady().pipe(
      map((caps) => withOverseasManualEntry(appWide, caps.overseasAddress)),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }
}
